import { apiClient } from '@/api/client'
import type { PermissionMatrix } from './types'

export async function fetchPermissionMatrix(): Promise<PermissionMatrix> {
  const { data } = await apiClient.get<PermissionMatrix>('/portal/admin/api/v2/permissions')
  return data
}

export async function updateRolePermission(
  roleId: number,
  permissionId: number,
  granted: boolean,
): Promise<void> {
  await apiClient.post('/portal/admin/permissions/api/update', {
    role_id: roleId,
    permission_id: permissionId,
    granted,
  })
}
